interface ErrorDisplayProps {
    errors: string[];
}

export default function ErrorDisplay({ errors }: ErrorDisplayProps) {
    return (
        <div className='bg-loving-100 border-l-4 border-loving-500 text-gray-700 px-4 py-2' role='alert'>
            <p className='font-semibold text-loving-500'>An error has occured</p>
            {errors.map(error => <p key={error}>{error}</p>)}
        </div>
    );
}
